import { Link } from 'react-router-dom'
import { getPropertyEditUrl } from '@/lib/utils/propertyNavigation'
import type { YardiPropertyNameLinkProps } from '../types/components'
import { PROPERTY_NAME_LINK_CLASS } from '../constants'

/**
 * Angular reports-yardi-invites: link property name when `property_id` is present.
 */
export function YardiPropertyNameLink({
  propertyId,
  propertyName,
  dataTestId,
}: YardiPropertyNameLinkProps) {
  const label = propertyName ?? ''

  if (propertyId == null || propertyId === '') {
    return <>{label}</>
  }

  return (
    <Link
      to={getPropertyEditUrl(propertyId)}
      data-testid={dataTestId}
      className={PROPERTY_NAME_LINK_CLASS}
    >
      {label}
    </Link>
  )
}
